import JSONAPIAdapter from '@ember-data/adapter/json-api'
import config from 'teacher-ui-client/config/environment'
import { service } from '@ember/service'
import type AuthToken from '@blakeelearning/auth/services/auth-token'
import { adapterHostAndNamespace } from 'teacher-ui-client/utils/uri'

const url = new URL(config.gravityCsvUrl)
export const { host, namespace } = adapterHostAndNamespace(url)
export const baseUrl = url.href

export default class GravityCsvV1Adapter extends JSONAPIAdapter {
  host = host

  namespace = namespace

  @service authToken!: AuthToken

  // @ts-expect-error - parent defines this as a property, we override with getter
  get headers() {
    return {
      Authorization: this.authToken.token,
      Accept: 'application/vnd.api+json',
    }
  }
}
